import React from 'react';
import './OurServices.css';
import { ReactComponent as ServiceIcon1 } from './icons/service-icon1.svg';
import { ReactComponent as ServiceIcon2 } from './icons/service-icon2.svg';
import { ReactComponent as ServiceIcon3 } from './icons/service-icon3.svg';
import { ReactComponent as ServiceIcon4 } from './icons/service-icon4.svg';
import { scrollToSection } from '../Header/Header';

interface Service {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
}

const services: Service[] = [
  {
    icon: ServiceIcon1,
    title: 'Transport mărfuri',
    description: 'Oferim servicii de transport mărfuri, adaptate nevoilor tale. Livrăm prompt și eficient, asigurând că marfa ta ajunge în cele mai bune condiții, oriunde în țară.',
  },
  {
    icon: ServiceIcon2,
    title: 'Cereale',
    description: 'Cumpărăm și vindem cereale de calitate, cu livrare rapidă direct din depozitele noastre.',
  },
  {
    icon: ServiceIcon3,
    title: 'Îngrășăminte chimice',
    description: 'Furnizăm îngrășăminte chimice, adaptate diverselor culturi agricole, pentru recolte consistente și bogate.',
  },
  {
    icon: ServiceIcon4,
    title: 'Agregate',
    description: 'Oferim nisip, pietriș și alte agregate de calitate, potrivite pentru orice proiect de construcție. Indiferent de proiect, susținem fiecare etapă a lucrării.',
  },
];

export const OurServices: React.FC = () => {
  return (
    <section className="our-services">
      <h2>Serviciile noastre</h2>
      <div className="services-container">
        {services.map((service, index) => {
          const Icon = service.icon;
          return (
            <div key={index} className="service-card">
              <div className="service-icon">
                <Icon />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              {/* <a href="#" className="service-link">
                Mai multe
              </a> */}
              <button onClick={() => scrollToSection('.contact-form-container')} className='main-button'>MAI MULTE</button>
            </div>
          );
        })}
      </div>
    </section>
  );
};
